import { SettingsProvider } from "./context/SettingsProvider";
import { UserProvider } from "./context/UserProvider";
import { CommentsProvider } from "./context/CommentsProvider";

import CollapsableWrapper from "./components/CollapsableWrapper";

import UserDetails from "./components/User/UserDetails";
import UserFormModal from "./components/User/UserFormModal";

import CommentsHeader from "./components/Comments/CommentsHeader";
import CommentsRoot from "./components/Comments/CommentsRoot";
import CommentsLoadMore from "./components/Comments/CommentsLoadMore";

import { getConfigs } from "./inc/functions";
import CommentEditor from "./components/Comments/CommentEditor";

function App() {

  const {common, user, comments} = getConfigs();

  return (
    <SettingsProvider config={common}>
      <UserProvider config={user}>
        <CommentsProvider config={comments}>
          <CollapsableWrapper>
            <UserDetails />
            <CommentsHeader />
            <CommentEditor btnText="Post Comment…" parentId={0} />
            <CommentsRoot />
            <CommentsLoadMore />
          </CollapsableWrapper>
          <UserFormModal />
        </CommentsProvider>
      </UserProvider>
    </SettingsProvider>
  );
}

export default App;
